import {
  AGENDAS_FETCH_REQUEST,
  AGENDAS_FETCH_SUCCESS,
  AGENDAS_FETCH_FAILURE,
  AGENDAS_CREATE_REQUEST,
  AGENDAS_CREATE_SUCCESS,
  AGENDAS_CREATE_FAILURE,
  AGENDAS_UPDATE_REQUEST,
  AGENDAS_UPDATE_SUCCESS,
  AGENDAS_UPDATE_FAILURE,
  AGENDAS_DELETE_REQUEST,
  AGENDAS_DELETE_SUCCESS,
  AGENDAS_DELETE_FAILURE,
  AGENDAS_SET_LOADING,
  AGENDAS_SET_ERROR,
  AGENDAS_CLEAR_ERROR
} from './agendasTypes.js';

const initialState = {
  items: [],
  loading: false,
  error: null
};

const agendasReducer = (state = initialState, action) => {
  switch (action.type) {
    case AGENDAS_FETCH_REQUEST:
    case AGENDAS_CREATE_REQUEST:
    case AGENDAS_UPDATE_REQUEST:
    case AGENDAS_DELETE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case AGENDAS_FETCH_SUCCESS:
      return {
        ...state,
        items: action.payload,
        loading: false,
        error: null
      };
    
    case AGENDAS_CREATE_SUCCESS:
      return {
        ...state,
        items: [...state.items, action.payload],
        loading: false,
        error: null
      };
    
    case AGENDAS_UPDATE_SUCCESS:
      return {
        ...state,
        items: state.items.map(item =>
          item.id === action.payload.id ? action.payload : item
        ),
        loading: false,
        error: null
      };
    
    case AGENDAS_DELETE_SUCCESS:
      return {
        ...state,
        items: state.items.filter(item => item.id !== action.payload),
        loading: false,
        error: null
      };
    
    case AGENDAS_FETCH_FAILURE:
    case AGENDAS_CREATE_FAILURE:
    case AGENDAS_UPDATE_FAILURE:
    case AGENDAS_DELETE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    
    case AGENDAS_SET_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    
    case AGENDAS_SET_ERROR:
      return {
        ...state,
        error: action.payload
      };
    
    case AGENDAS_CLEAR_ERROR:
      return {
        ...state,
        error: null
      };
    
    default:
      return state;
  }
};

export default agendasReducer;